var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-message',[_vm._v(_vm._s(_vm.$t('welcome-x', [(_vm.user.fname + ' ' + _vm.user.lname)])))])}
var staticRenderFns = []

export { render, staticRenderFns }